import Http from './http'

export class GenericService {
  constructor(url) {
    this.url = url
  }

  getAll(filter, like) {
    let url = this.url

    if (filter) {
      url += `?${this.buildFilterUrl(filter, like)}`
    }

    return Http.get(url)
  }

  buildFilterUrl(filter) {
    return Object.keys(filter)
      .map((key) => {
        if (key === 'orderBy') {
          return filter.orderBy.map(
            (order) => `orderBy[]=${order.orderBy},${order.direction || 'asc'}`
          )
        }
        if (filter[key] === null || filter[key] === '') {
          return ''
        }
        return `${key}=${filter[key]}`
      })
      .join('&')
  }

  create(data) {
    return Http.post(this.url, data)
  }

  edit(id, data) {
    return Http.put(`${this.url}/${id}`, data)
  }
}
